import { tabletQuery } from '@globals/themes/themeConstants'
import Dialog, { DialogProps } from '@mui/material/Dialog'
import { SxProps } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import FullScreenAnimation from '@shared/animations/FullScreenAnimation'
import { T } from '@transifex/react'
import { ReactNode, useState } from 'react'
import DraftAndSchduledView from './DraftAndSchduledView/DraftAndSchduledView'
import RecognitionMobileDrawer from './RecognitionMobileDrawer'
import SendRecognitionView from './sendRecognitionView/SendRecognitionView'
import { useSendRecognitionFormStore } from './sendRecognitionView/useSendRecognitionFormStore'
import useRecognitionModal, { RecognitionModalViews } from './useRecognitionModal'

export const modalStyle: SxProps = {
  borderRadius: 4,
  overflowX: 'hidden',
  border: 'none',
}

export type RecognitionModalContent = {
  [key in RecognitionModalViews]: {
    content: ReactNode
  }
}

const RecognitionModal: React.FC = () => {
  const [isAnimationShowing, setIsAnimationShowing] = useState<boolean>(false)
  const { dialogData, isOpen, closeDialog } = useRecognitionModal()
  const isTablet = useMediaQuery(tabletQuery)
  const { isFormDirty } = useSendRecognitionFormStore()

  const contents: RecognitionModalContent = {
    [RecognitionModalViews.SendRecognition]: {
      content: <SendRecognitionView setShowAnimation={setIsAnimationShowing} />,
    },
    [RecognitionModalViews.DraftAndInProgressRecognitions]: {
      content: <DraftAndSchduledView />,
    },
  }

  const handleClose: DialogProps['onClose'] = (event, reason) => {
    if (!!reason && reason === 'backdropClick' && isFormDirty) return
    closeDialog()
  }

  return (
    <>
      {isTablet ? (
        <RecognitionMobileDrawer
          isOpen={isOpen}
          recognitionDialogData={dialogData}
          onClose={handleClose}
          contents={contents}
        />
      ) : (
        <Dialog
          open={isOpen}
          onClose={handleClose}
          slotProps={{ paper: { sx: modalStyle } }}
          disableAutoFocus
          disableEnforceFocus>
          {dialogData && contents[dialogData.view].content}
        </Dialog>
      )}
      <FullScreenAnimation
        title={<T _str="You just made someone's day!" />}
        isVisible={isAnimationShowing}
        onClose={() => setIsAnimationShowing(false)}
      />
    </>
  )
}

export default RecognitionModal
